module.exports = __webpack_public_path__ + "4c30e499dabb7c77292d60e7aa86fa76.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/dollar.svg
// module id = 179
// module chunks = 0